import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConnectionsPage } from '@/features/data/connections/connection-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Connexions de données d'un projet (lot L07). */
export const Route = createFileRoute('/$tenant/projects/$projectId/connections/')({
  component: ConnectionsRoute,
});

function ConnectionsRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="connections"
      crumbs={[{ label: t('nav.items.connections') }]}
    >
      <ConnectionsPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
